import { API_TBase } from "./API";
import { TNullBool } from "./nullbool";

const MESSAGES = {
  labels: {
    yes: "Yes",
    no: "No",
  },
};

export type API_TSocItem = {
  [key: string]: any;
  soc_code: string;
  soc_name: string;
  job_title: string;
  industry: string;
  eligible_for_skilled_workers: boolean;
  going_rate: number;
  ninety_percent: number;
  eighty_percent: number;
  seventy_percent: number;
  eligible_for_ph_d: boolean;
  sol_eng: boolean;
  sol_scotland: boolean;
  sol_wales: boolean;
  sol_northern_ireland: boolean;
  description: string;
  entry: string;
  tasks: string;
  analytic_class: string;
  operational_category: string;
  soc_type: string;
  search: string;
  soc_code_eligible_for_outside: TNullBool;
} & API_TBase;

export type TSocItem_Table = {
  id: string;
  soc_code: string;
  soc_type: string;
  soc_name: string;
  job_title: string;
  analytic_class: string[];
  eighty_percent: number;
  sol_scotland: string;
  description: string;
  operational_category: string[];
  industry: string;
  ninety_percent: number;
  going_rate: number;
  seventy_percent: number;
  entry: string;
  search: string;
  sol_northern_ireland: string;
  sol_wales: string;
  sol_eng: string;
  eligible_for_skilled_workers: string;
  eligible_for_ph_d: string;
  tasks: string[];
  soc_code_eligible_for_outside: boolean;
};

export type TSocItem_Profile = {
  soc_code: string;
  soc_type: string;
  soc_name: string;
  job_title: string;
  analytic_class: string[];
  eighty_percent: number;
  sol_scotland: string;
  operational_category: string[];
  industry: string;
  ninety_percent: number;
  going_rate: number;
  seventy_percent: number;
  search: string;
  sol_northern_ireland: string;
  sol_wales: string;
  sol_eng: string;
  eligible_for_skilled_workers: string;
  eligible_for_ph_d: string;
};

export type TSocItem_Details = {
  description: string;
  entry: string;
  tasks: string[];
  job_titles: string[];
};

const castValue = (payload: string): string => {
  return payload || "―";
};

const castNumber = (payload: number): number => {
  return payload ? Number(payload) : 0;
};

const castBoolean = (payload: boolean): string => {
  const { yes, no } = MESSAGES.labels;

  return payload ? yes : no;
};

const castArray = (payload: string, separator = ","): string[] => {
  return payload ? payload.split(separator) : [];
};

const convertNullBoolToBool = (section: TNullBool) => {
  return section.Valid && section.Bool;
};

export const convertSocItemForTable = (a: API_TSocItem): TSocItem_Table => {
  return {
    id: String(a.ID),
    soc_code: castValue(a.soc_code),
    soc_name: castValue(a.soc_name),
    job_title: castValue(a.job_title),
    industry: castValue(a.industry),
    eligible_for_skilled_workers: castBoolean(a.eligible_for_skilled_workers),
    going_rate: castNumber(a.going_rate),
    ninety_percent: castNumber(a.ninety_percent),
    eighty_percent: castNumber(a.eighty_percent),
    seventy_percent: castNumber(a.seventy_percent),
    eligible_for_ph_d: castBoolean(a.eligible_for_ph_d),
    sol_eng: castBoolean(a.sol_eng),
    sol_scotland: castBoolean(a.sol_scotland),
    sol_wales: castBoolean(a.sol_wales),
    sol_northern_ireland: castBoolean(a.sol_northern_ireland),
    description: castValue(a.description),
    entry: castValue(a.entry),
    tasks: castArray(a.tasks, ";"),
    analytic_class: castArray(a.analytic_class),
    operational_category: castArray(a.operational_category),
    soc_type: castValue(a.soc_type),
    search: castValue(a.search),
    soc_code_eligible_for_outside: convertNullBoolToBool(a.soc_code_eligible_for_outside),
  };
};

export const convertSocItemForDescription = (a: API_TSocItem): TSocItem_Details => {
  return {
    description: castValue(a.description),
    entry: castValue(a.entry),
    tasks: castArray(a.tasks, ";"),
    job_titles: a.job_titles,
  };
};
